<template>
  <Modal
    :no-backdrop="true"
    classs="justify-start ml-[294px] box-border mt-[118px] items-start w-[38.57%] onboarding-global-style"
    v-if="show"
    c-class="max-w-[395px] min-w-[auto]"
    m-class="feature-promotion"
    @outsize="onOutSize">
    <template #default>
      <div class="content flex flex-col">
        <div class="right--content">
          <div
            class="union absolute !w-6 !h-6 bg-light-300 !right-2 !top-2 flex items-center justify-center cursor-pointer rounded-[3px]"
            @click="close">
            <i class="icon icon-close" />
          </div>
          <div style="width: 100%; overflow: hidden">
            <img :src="currentStep?.gif" style="width: 100%" alt="" />
          </div>
        </div>

        <div class="bg-dark-400 w-full !p-4">
          <div class="text-light-100 text-base !pb-3">{{ currentStep?.title }}</div>
          <div class="text-dark-mode-low-contrast text-sm !mb-6 leading-[22px]">
            {{ textContent }}
            <a
              v-if="currentStep?.welcome"
              href="https://www.youtube.com/watch?v=e2WFUwUkk68"
              target="_blank"
              class="text-primary-200"
              >Watch Tutorial</a
            >
          </div>
          <div class="flex items-center">
            <div
              v-show="step > 0"
              class="w-[49px] !h-10 !mr-4 text-base text-light-100 flex items-center justify-center cursor-pointer"
              @click="back">
              Back
            </div>
            <div
              :class="{ active: step === 2 }"
              class="btn btn-next-step cursor-pointer flex-1 text-base text-light-100"
              @click="next">
              {{ textButton }}
              <i v-if="step < 2" class="icon icon-arrow-right right-arrow" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';
import type { TypeShop } from '@/app/types/editor/shop';
import config from '@/app/editor/config';
import emitter from '@/emitter';
import { cloneDeep } from '@/utils/common';
import { app } from '@/store';
import gif1 from '../../assets/images/PromotionOnboarding-1.gif';
import gif2 from '../../assets/images/PromotionOnboarding-2.gif';
import gif3 from '../../assets/images/PromotionOnboarding-3.gif';

export default defineComponent({
  name: 'FeaturePromotionModal',
  data: function () {
    return {
      onBoardingBannerIcon: `${config.domain()}${config.baseURL()}/static/icons/onboarding-banner.svg`,
      step: 0,
      show: true,
      features: [
        {
          step: 0,
          welcome: true,
          title: this.$t('modals.onboardingGS.screen1.title2'),
          description: this.$t('modals.onboardingGS.screen1.desc'),
          gif: gif1,
        },
        {
          step: 1,
          welcome: false,
          title: this.$t('modals.onboardingGS.screen2.title'),
          description: this.$t('modals.onboardingGS.screen2.desc'),
          gif: gif2,
        },
        {
          step: 2,
          welcome: false,
          title: this.$t('modals.onboardingGS.screen3.title'),
          description: this.$t('modals.onboardingGS.screen3.desc'),
          gif: gif3,
        },
      ],
    };
  },
  computed: {
    ...mapState('app', {
      shopInfo: (state: any): TypeShop => state.shopInfo,
      shopMeta: (state: any): TypeShop => state.shopMeta,
    }),
    currentStep() {
      return this.features.find((fea: any) => fea.step === this.step);
    },
    textButton() {
      if (this.step === 0) return 'Explore Benefits';
      if (this.step === 2) return 'Check it out';
      return 'More Benefits';
    },
    textContent() {
      return this.currentStep?.description || '';
    },
  },
  created() {
    const meta = this.shopMeta as any;
    if (meta.onboardingGlobalStyle.featurePromotion) {
      return;
    }

    (window as any).featurePromotionOB = true;
    const payload = cloneDeep(this.shopMeta);
    payload.onboardingGlobalStyle.featurePromotion = true;
    this.updateShopMeta(payload);
  },
  methods: {
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    updateFeaturePromotionMeta() {
      (app as any).$store.state['app']['shopMeta']['onboardingGlobalStyle']['featurePromotion'] = true;
    },
    onOutSize() {
      this.show = false;
      this.close();
    },
    close() {
      this.updateFeaturePromotionMeta();
    },
    back() {
      if (this.step <= 0) return (this.step = 0);
      return this.step--;
    },
    next() {
      if (this.step === 2) {
        emitter.emit('tryNowOnboarding');
      }
      if (this.step >= 2) return this.updateFeaturePromotionMeta();
      return this.step++;
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
// eslint-disable-next-line vue-scoped-css/no-unused-selector
.transform-x {
  transform: scaleX(-1);
}
.header {
  position: relative;
  z-index: 1;
  width: 100%;

  .logo-gp {
    position: absolute;
    left: 32px;
    top: 32px;
  }

  .union {
    @include flex-align-justify-center;
    width: 32px;
    height: 32px;
    position: absolute;
    cursor: pointer;
    background: #ffffff;
    border-radius: 3px;
    top: 32px;
    right: 32px;

    .icon-close {
      font-size: 21px;
    }
  }
}
.content {
  @include flex-center;
  height: 100%;
  position: relative;
  .btn-back {
    width: 49px;
    height: 40px;
  }

  .btn-next-step {
    background: #494949;
    border-radius: 3px;
    color: #fff;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    height: 40px;

    &:hover {
      background: #494949;
    }

    .right-arrow {
      margin-left: 10px;
    }
    &.active {
      background: #3c67ff;
    }
  }

  .right--content {
    flex: 75%;
    background: rgba(216, 225, 255, 0.3);
    display: flex;
    justify-content: center;
    height: 100%;
    &:hover {
      .union {
        display: flex;
      }
    }
    .union {
      display: none;
    }
  }

  // eslint-disable-next-line vue-scoped-css/no-unused-selector
  .first-right--content {
    width: 85%;
    background: rgba(216, 225, 255, 0.3);
    display: flex;
    justify-content: center;
    height: 100%;
    padding-left: 32px;
    padding-right: 51px;

    img {
      padding: 130px 32px 130px 100px;
    }
  }

  .left--content {
    flex: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 51px;
    padding-right: 51px;
    background: #fff;
    position: relative;

    .title {
      height: 160px;
    }

    .step {
      color: #9e9e9e;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      margin-bottom: 16px;
    }

    .help {
      color: #547aff;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
    }

    .customer-title {
      font-size: 20px;
      font-weight: 600;
      color: #212121;
      margin-top: 10px;
    }

    .description {
      margin-top: 14px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #676767;
      width: 340px;
    }

    .tutorial {
      color: #3c67ff;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      margin-top: 16px;
      cursor: pointer;

      .link {
        text-decoration: none;
      }
    }
  }
}
</style>
